import Navbar from "../../shared/navbar";
import { useForm } from "react-hook-form";
import axios from "axios";
import "./forgotPws.css";
import { ALERT, BASE_URL } from "../../config/constants";

export default function ForgotPSW() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  //<<<...Petición para restablecer contraseña...>>>
  function formForgotPws(data) {
    axios
      .put(BASE_URL + "/auth/login/forgot-password", data)
      .then((res) => {
        //localStorage.setItem("token", res.data.verificationLink);
        ALERT.fire({
          icon: "info",
          title: "Revisa tu correo para restablecer contraseña",
        });
      })
      .catch(function (error) {
        ALERT.fire({
          icon: "error",
          title:
            "¡...Error de envío, verificaque tu correo esté bien escrito...!",
        });
      });
  }
  ///<<<...Fin envío de petición...>>>

  return (
    <div className="ForgotPWS">
      <div className="tittle">
        <div className="cabecera">
          <div className="navbarRegister">
            <Navbar />
          </div>
        </div>
      </div>
      <div className="boxEmail">
        <section id="subsection-email">
          <section className="pb-4">
            <div className="bg-white border rounded-5">
              <div className="container">
                <br />
                <p className="text-center mx-auto">
                  Escribe tu correo para restablecer la contraseña y da click en
                  el botón envíar
                </p>
              </div>

              <section className="w-100 p-4 d-flex justify-content-center pb-4">
                <div className="form-outline" style={{ width: "22rem" }}>
                  <form onSubmit={handleSubmit(formForgotPws)}>
                    <label
                      className="form-label"
                      htmlFor="typeEmail"
                      style={{ marginLeft: 0 }}
                    >
                      Correo
                    </label>
                    <input
                      type="email"
                      place="true"
                      className="form-control"
                      {...register("email", { required: true })}
                      id="email"
                      aria-describedby="emailHelp"
                      placeholder="example@email.com"
                    />
                    {errors?.email?.type === "required" && (
                      <span className="text-danger">Correo es obligatorio</span>
                    )}
                    <div className="form-notch">
                      <div
                        className="form-notch-leading"
                        style={{ width: 9 }}
                      />
                      <div
                        className="form-notch-middle"
                        style={{ width: "71.2px" }}
                      />
                      <div className="form-notch-trailing" />
                    </div>
                    <div className="p-4 text-center border-top mobile-hidden">
                      <div className="d-grid gap-2 col-12 mx-auto">
                        <button className="btn btn-primary" type="submit">
                          Enviar
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </section>
            </div>
          </section>
        </section>
      </div>
    </div>
  );
}
